export const German = {
  "Flash Technologies L.L.C-FZ": "Flash Technologies L.L.C-FZ",
  "Audited by": "Geprüft von",
  Flash: "Flash",
  Technologies: "Technologies",
  "Buy Flash": "Flash kaufen",
  "Flash Technologies creates a money transfer ecosystem.":
    "Flash Technologies schafft ein Ökosystem für Geldüberweisungen.",
  "Flash Transfer is the world's first platform that allows you to buy crypto with cash, transfer, or sell cryptocurrencies for cash through our network of merchants, with reasonable fees. Flash Wallet, our non-custodial wallet, has a smart contract that you can use to transfer your crypto in the event of death.  Find the best fees with Flash Dex, our aggregator swap & bridge!":
    "Flash Transfer er verdens første platform, der giver dig mulighed for at købe krypto med kontanter, overførsel eller sælge kryptovalutaer for kontanter gennem vores netværk af forhandlere med rimelige gebyrer. Flash Wallet, vores non-custodial wallet, har en smart contract, som du kan bruge til at overføre din krypto i tilfælde af død. Find de bedste gebyrer med Flash Dex, vores aggregator swap & bridge!",
  CONTACT: "KONTAKT",
  "Contact Us": "Kontakt",
  "Whether you have a question about one of our services or want to get involved in our mission, we are ready to help.":
    "Ganz gleich, ob Sie eine Frage zu einer unserer Dienstleistungen haben oder sich an unserer Mission beteiligen möchten, wir sind bereit, Ihnen zu helfen.",
  "Follow us:": "Folgen Sie uns:",
  "First Name": "Vorname",
  "Last Name": "Nachname",
  "Your Email Address": "Ihre E-Mail Adresse",
  "Tell us about your project": "Erzählen Sie uns von Ihrem Projekt",
  "Send Message": "Send Message",
  "Type Here": "Hier tippen",
  Our: "Unser",
  "CORE TEAM": "CORE TEAM",
  "has worked with": "hat gearbeitet mit",
  "Core Team": "Kernteam",
  "Aladdin CEO & Founder": "Aladdin CEO & Gründer",
  "CEO & Founder of": "CEO & Gründer von",
  Blocklabchain: "Blocklabchain",
  Hunos: "Hunos",
  "Safi CCO & Co-Founder": "Safi CCO & Mitbegründer",
  "Les Artisans d’Orient": "Les Artisans d'Orient",
  "Junior COO": "Junior COO",
  "Communication English & German. Works in":
    "Kommunikation Englisch & Deutsch. Arbeitet in einer",
  "Diplomatic Institution": "diplomatischen Einrichtung ",
  "Binance feed creator": " Binance-Feed-Ersteller",
  "Mimirk CPRO": "Mimirk CPRO",
  "Chief Public Relations Officer. Works in":
    "Verantwortlicher für Marketing. Arbeitet als",
  "Public Relations":
    "Experte für Marketing und Öffentlichkeitsarbeit",
  "Dev. Team": "Dev. Team",
  "Community Manager": "Community Manager",
  "Frontend Developer": "Front-end",
  "Oleksii Developer": "Oleksii Entwickler",
  "Agent IA": "Agent IA",
  "Agent IA role":
    "Social-Media-Management & Wettbewerbsbeobachtung",
  "Ernest CTO": "Ernest CTO",
  "Full stack & Blockchain Developer": "Full Stack",
  "Jawad Developer": "Jawad Entwickler",
  "Full stack Developer": "Full-Stack-Entwickler",
  "Ahsan Developer": "Mikhail Entwickler",
  "Umair Developer": "Umair Entwickler",
  "Usama Developer": "Vilgelm Entwickler",
  "Vadim Developer": "Vadim Entwickler",
  "Blockchain Developer": "Blockchain-Entwickler",
  "Alex Developer": "Alex Entwickler",
  "Frontend & Blockchain Developer": "Frontend & Blockchain Entwickler",
  "Hassam Editor video": "Hassam Editor Video",
  "Video creation and editor": "Videoerstellung und -bearbeitung",
  "Runnart Designer": "Runnart Designer",
  "Administrative graphic": "Verwaltungsgrafik",
  "White paper": "White paper",
  "& App logo designer": "& App logo designer",
  "Eznau Illustrator": "Eznau Illustrator",
  "Graphic flyers, logos": "Grafikflyer, logos",
  "NFT for all products of": "NFT für alle Produkte von",
  "Flash Technologies": "Flash Technologies",
  "Numa Designer UI/UX": "Numa Designer UI/UX",
  "Flash Transfer": "Flash-Übertragung",
  "Flash Wallet App": "Flash Wallet App",
  "UI/UX designer": "UI/UX designer",
  "UI/UX designer for Flash Technologies":
    "UI/UX-Designer für Flash Technologies",
  "Products": 'Produkte',
  "for": '',
  "ITO Designer": "ITO Designer",
  FAQ: "FAQ",
  "What is Flash technologies?": "Was sind Flash Technologies?",
  "Flash Technologies is the name that represents all Flash projects.":
    "Flash Technologies ist der Name, der für alle Flash-Projekte steht.",
  "How can I buy Flash?": "Wie kann ich Flash kaufen?",
  "You can buy Flash token directly on":
    "Sie können unsere Token direkt auf",
  "What is Flash Transfer?": "Was ist Flash Transfer?",
  "Flash Transfer is the main project of Flash Technologies. We will be able to bank people who do not have a bank account or who wish to free themselves from traditional banks. We can exchange cash for crypto via our various partners. Users of this service will be able to make transfers worldwide.":
    "Flash Transfer ist das Hauptprojekt von Flash Technologies. Wir werden in der Lage sein, Menschen zu überweisen, die kein Bankkonto haben oder sich von den traditionellen Banken befreien wollen. Wir können über unsere verschiedenen Partner Bargeld in Kryptowährungen umtauschen. Die Nutzer dieses Dienstes werden in der Lage sein, weltweit Überweisungen zu tätigen.",
  "What are the advantages of buying Flash ?":
    "Was sind die Vorteile des Flash-Kaufs?",
  "Your Flash increases in value according to the evolution of the course. When Flash Technologies projects evolve, it has a positive impact on the price.":
    "Der Wert Ihres Flash-Kurses steigt mit der Entwicklung des Kurses. Wenn sich die Projekte von Flash Technologies weiterentwickeln, wirkt sich dies positiv auf den Preis aus.",
  "On which site will the token be listed?":
    "Auf welcher Website wird der Token aufgeführt?",
  "The token will be listed on CEX and DEX.":
    "Der Token wird auf CEX und DEX gelistet.",
  "Why transaction fees?": "Warum Transaktionsgebühren?",
  "Transaction fees support the project.":
    "Die Transaktionsgebühren unterstützen das Projekt.",
  "Whitepaper EN": "Weißbuch DE",
  Presentation: "Präsentation",
  "Using Flash Wallet": "Flash Wallet verwenden",
  SERVICES: "DIENSTLEISTUNGEN",
  "(replace busd with ETH)": "",
  "Flash Ecosystem": "Flash-Ökosystem",
  "Discover all our services.": "Entdecken Sie alle unsere Dienstleistungen.",
  "Cash-in and cash-out: exchange your cash for crypto or crypto for cash. Buy crypto directly from our more than 470,000 MoneyGram partners. You can also send your cryptocurrency and the receiver withdraws it in fiat all over the world using your non-custodial wallet (Flash Wallet, Metamask, Phantom, and others).":
    "Cash-in und Cash-out: Tauschen Sie Bargeld gegen Krypto oder Krypto gegen Bargeld. Kaufen Sie Krypto direkt bei mehr als 470.000 MoneyGram-Partnern. Sie können Krypto auch senden; der Empfänger führt weltweit Cash-out in Fiat durch, mit einer Non-Custodial-Wallet (Flash Wallet, Metamask, Phantom u. a.).",
  "Flash Dex": "Flash Dex",
  "Flash dex dapps is an all-in-one swap and bridge that allows users to swap their crypto assets from the same blockchain or from one blockchain to another. With the best possible direct market fees.":
    "Flash dex dapps ist ein All-in-One-Swap und eine Bridge, die es Nutzern ermöglicht, ihre Krypto-Assets von derselben Blockchain oder von einer Blockchain zu einer anderen zu tauschen. Mit den bestmöglichen Direktmarktgebühren.",
  "Flash Technologies has built a fully integrated cryptocurrency wallet that holders and merchants can use to buy, sell, stake, earn rewards and browse on internet. Flash Wallet has a special function that is unique in cryptospace. A very important feature that users will enjoy everywhere in the world.":
    "Flash Technologies hat eine vollständig integrierte Krypto-Wallet entwickelt, mit der Inhaber und Händler kaufen, verkaufen, staken, Belohnungen verdienen und im Internet surfen können. Flash Wallet bietet die einzigartige Dead-Wallet-Funktion: einen Smart Contract, um Krypto bei Verlust der Wiederherstellungsphrase oder im Todesfall wiederherzustellen oder zu übertragen. Demnächst: Geld an eine Telefonnummer senden, auch wenn der Empfänger noch keine Krypto-Wallet hat.",
  "Flash Wallet": "Flash-Geldbörse",
  "Dead Wallet": "Flash Dead",
  "The 'dead-wallet' function. This function enables the recovery of cryptos in another wallet in case of loss of seed phrase and in the event of a death of a crypto holder. It is embedded with a smart-contract linked to a timer that automatically triggers the transfer of funds out of the wallet after a period of time has elapsed. With extra security if ever the dead wallet doesn't have enough gas costs.":
    "Die „Dead-Wallet“-Funktion. Diese Funktion ermöglicht die Wiederherstellung von Kryptowährungen in einem anderen Wallet im Falle eines Verlusts der Wiederherstellungsphrase oder im Falle des Todes des Kryptowährungsinhabers. Das Wallet ist mit einem Smart Contract ausgestattet, der mit einem Timer verknüpft ist, der nach einer gewissen Zeit den Geldtransfer aus dem Wallet auslöst; Der Empfänger muss die Kryptowährungen beanspruchen. Um diese Funktion zu nutzen, besuchen Sie die Anwendung flash-wallet.com.",
  "Flash Pay": "Flash Pay",
  "FlashPay, escrow agreements can be created quickly by buyer or seller. Once receipt of goods or services is confirmed funds are immediately transferred to the seller via the smart contract. In the event of a dispute, Flash Pay settles the dispute with the evidence received. At no time are the funds held by Flash Pay, everything is decentralized via the smart contract. Flash Pay can only validate or refuse the payment, nothing else.":
    "Mit FlashPay können Treuhandverträge schnell vom Käufer oder Verkäufer erstellt werden. Sobald der Erhalt von Waren oder Dienstleistungen bestätigt ist, werden die Gelder über den Smart Contract sofort an den Verkäufer überwiesen. Im Streitfall schlichtet Flash Pay den Streit anhand der erhaltenen Beweise. Die Gelder werden zu keinem Zeitpunkt von Flash Pay gehalten, alles läuft dezentral über den Smart Contract. Flash Pay kann die Zahlung nur validieren oder ablehnen, sonst nichts.",
  "Customers and merchants have the opportunity to earn rewards by using the staking protocol. Each month stakers receive a % of our staking pool.":
    "Kunden und Händler haben die Möglichkeit, durch die Nutzung des Einsatzprotokolls Prämien zu verdienen. Jeden Monat erhalten die Staker einen Prozentsatz unseres Staking-Pools.",
  "Flash Staking": "Blitzabsteckung",
  "Flash audit will audit smart contracts (tokens, bridges, staking, all types of dapps) and blockchains of our partners/customers on all networks.":
    "Flash Audit wird Smart Contracts (Tokens, Bridges, Staking, alle Arten von Dapps) und Blockchains unserer Partner/Kunden auf allen Netzwerken auditieren. Jeder Partner/Kunde, der in unser Ökosystem aufgenommen werden möchte, muss unser Sicherheitsaudit durchlaufen, um sicherzustellen, dass kein bösartiger Code vorhanden ist.",
  "Each partner/customer who would like to be in our ecosystem will have to go through our security audit to make sure there is no malicious code.":
    "Each partner/customer who would like to be in our ecosystem will have to go through our security audit to make sure there is no malicious code.",
  "Flash Audit": "Flash-Audit",
  "Flash Launchpad": "Flash Launchpad",
  "Flash pad is our launchpad for upcoming IDOs and allows crypto projects to create their tokens (Ethereum, BNB Chain, Polygon, Base, Avax, Cronos, Arbitrum, Blast) and raise funds in pre-sales or fair launches.You can also use the airdrop feature and the audit bot to quickly audit tokens.":
    "Flashpad ist unser Launchpad für aufstrebende IDOs und ermöglicht es Krypto-Projekten, ihre Token (BNB Chain, Polygon, Eth & Cronos) zu erstellen und durch Vorverkäufe oder Messelaunches Geld zu sammeln.",
  "Secured blockchain": "Gesicherte Blockchain",
  "Single transaction": "Einzelne Transaktion",
  "Deflationary token": "Deflationäre Token",
  "Replace a Bank Account": "Ersetzen eines Bankkontos",
  "WE ARE SUPPORTED": "WIR WERDEN UNTERSTÜTZT",
  "Flash Recharge Card": "Flash Recharge Card",
  "Flash Recharge": "Flash Recharge",
  "The Flash recharge is a prepaid card that allows users to top up their account in $ BUSD on the Flash wallet without any intermediary.":
    "The Flash recharge is a prepaid card that allows users to top up their account in $ BUSD on the Flash wallet without any intermediary.",
  "Flash Recharge allows users to top up their balance on Flash Wallet.":
    "Flash Recharge allows users to top up their balance on Flash Wallet.",
  "The Flash recharge's cards will be printed at the time of purchase for an eco-responsible approach.":
    "The Flash recharge's cards will be printed at the time of purchase for an eco-responsible approach.",
  "Cash to crypto and vice versa.":
    "Von Bargeld zu Kryptowährungen und umgekehrt.",
  "DOWNLOAD FROM": "DOWNLOAD FROM",
  "Our Services": "Unsere Dienstleistungen",
  "App": "App",
  Tokenomics: "Tokenomics",
  Partnership: "Partnerschaft",
  Roadmap: "Straßenkarte",
  NFT: "NFT",
  Team: "Team",
  Whitepaper: "Whitepaper",
  Audit: "Prüfung",
  "Become a Partner": "Partner werden",
  'Presale': "Presale",
  "Privacy Policy": "Datenschutzbestimmungen",
  "Legal Notice": "Rechtlicher Hinweis",
  License: "Lizenz",
  "Flash Technologies : Business Center 1, M Floor, The Meydan Hotel, Nad Al Sheba, Dubai, U.A.E.":
    "Flash Technologies: Business Center 1, M Floor, The Meydan Hotel, Nad Al Sheba, Dubai, U.A.E.",
  "Flash Technologies : 66 Avenue Des Champs Elysées,  75008, Paris.":
    "Flash Technologies : 66 Avenue Des Champs Elysées,  75008, Paris.",
  "Flash Technologies : Abidjan-Cocody, Les II Plateaux, 7ème Tranche, Abidjan.":
    "Flash Technologies : Abidjan-Cocody, Les II Plateaux, 7ème Tranche, Abidjan.",
  Pages: "Seiten",
  Documents: "Dokumente",
  Legal: "Legal",
  "Join Our Newsletter": "Newsletter abonnieren",
  "Your email address": "Ihre E-Mail Adresse",
  Subscribe: "Abonnieren",
  "Anti-spam": "Anti-Spam:",
  "Anti-spam answer": "Anti-Spam-Antwort",
  "Anti-spam answer required": "Bitte lösen Sie die Anti-Spam-Aufgabe.",
  "Incorrect anti-spam answer": "Falsche Anti-Spam-Antwort. Erneut versuchen.",
  "Already subscribed": "Sie sind bereits angemeldet.",
  "Email is required!": "E-Mail ist erforderlich!",
  "Your message has been sent!": "Ihre Nachricht wurde gesendet!",
  "Error sending message!": "Fehler beim Senden der Nachricht!",
  "Email service temporarily unavailable":
    "E-Mail-Dienst vorübergehend nicht verfügbar. Bitte erneut versuchen oder an contact@flash-technologies.org schreiben.",
  "Sending…": "Senden…",
  "Will send you weekly updates for your better finance management.":
    "Wir senden Ihnen wöchentliche Updates für Ihr besseres Finanzmanagement.",
  Partners: "Partners",
  Contact: "Contact",
  Staking: "Abstecken",
  "Invest in your Future": "Investieren Sie in Ihre Zukunft",
  "Clients can stake Flash or our approved partner's tokens for a certain period of time in order to earn rewards and bonuses":
    "Kunden können Flash oder die Token unserer anerkannten Partner für einen bestimmten Zeitraum einsetzen, um Belohnungen und Boni zu erhalten.",
  Stake: "Pfahl",
  "Stake FLASH and receive rewards.":
    "Setzen Sie FLASH ein und erhalten Sie Belohnungen.",
  "Complete Staking Term": "Vollständige Absteckungsfrist",
  "Users can choose the staking terms and hold their stake for s period of time to earn higher yield bonus returns.":
    "Die Benutzer können die Einsatzbedingungen wählen und ihren Einsatz über einen bestimmten Zeitraum halten, um höhere Bonuserträge zu erzielen.",
  "Pay via Flash and partner tokens": "Bezahlen mit Flash- und Partner-Tokens",
  "After every successful stake, users are rewarded with Flash token as a farming bonus and partners tokens.":
    "Nach jedem erfolgreichen Einsatz werden die Nutzer mit Flash-Tokens als Farming-Bonus und Partner-Tokens belohnt.",
  "Listing & Partners": "Listing & Partner",
  "Seen in the media": "In den Medien gesehen",
  "GET YOUR NFT UTILITY": "HOLEN SIE SICH IHR NFT-DIENSTPROGRAMM",
  Airdrop: "Airdrop",
  "Each month receive Flash in your wallet.":
    "Jeden Monat erhalten Sie Flash in Ihrem Portemonnaie.",
  "Holders of the AIRDROP NFTS receive Flash tokens every month. The amount differs depending on the rarity of the NFT. It also gives access to other benefits including the vip club (call nft & tokens), whitelist, discounts and other benefits that will be disclosed in the future.":
    "nhaber des AIRDROP NFTS erhalten jeden Monat Flash-Token. Der Betrag variiert je nach Seltenheit des NFT. Außerdem erhalten sie Zugang zu weiteren Vorteilen wie dem VIP-Club (NFT und Token anrufen), einer Whitelist, Rabatten und anderen Vorteilen, die in Zukunft bekannt gegeben werden.",
  "Ranking Increase": "Ranglistenerhöhung",
  "Will quickly increase the privilege ranking.":
    "Wird die Privilegierung schnell erhöhen.",
  "The NFTS RANKING INCREASE allow you to increase quickly your ranking points on Flash Transfer Website. The earned points depend on the rarity of the NFT. It also gives access to other benefits including the vip club (call nft & tokens), whitelist, discounts and other benefits that will be disclosed later.":
    "Mit dem NFTS RANKING INCREASE können Sie schnell Ihre Ranglistenpunkte auf der Flash Transfer Website erhöhen. Die verdienten Punkte hängen von der Seltenheit des NFT ab. Es gibt auch Zugang zu anderen Vorteilen, einschließlich der VIP-Club (Call nft & Token), Whitelist, Rabatte und andere Vorteile, die später offenbart werden.",
  "Discount on transaction fees": "Rabatt auf Transaktionsgebühren",
  "Will entitle you to fees on money transfer site transactions.":
    "Sie haben Anspruch auf Gebühren für Transaktionen auf Geldtransfer-Websites.",
  "The NFTS DISCOUNT ON TRANSACTION FEES provide discounts on transaction fees. The reduction is bigger depending on the rarity of the NFT. It also gives access to other benefits including the vip club (call nft & tokens), whitelist, discounts and other benefits that will be disclosed later.":
    "Die NFTS DISCOUNT ON TRANSACTION FEES bieten Rabatte auf Transaktionsgebühren. Die Ermäßigung ist je nach Seltenheit des NFT größer. Es gibt auch Zugang zu anderen Vorteilen wie dem VIP-Club (NFT & Token anrufen), der Whitelist, Rabatten und anderen Vorteilen, die später bekannt gegeben werden.",
  "Random effect": "Zufälliger Effekt",
  "Every 3 months or 6 months the function of the NFT changes.":
    "Alle 3 oder 6 Monate ändert sich die Funktion des NFT.",
  "The NFTS RANDOM EFFECT change abilities every 4 months. The benefit is greater depending on the rarity of the NFT. It also gives access to other benefits including the vip club (call nft & tokens), whitelist, discounts and other benefits that will be disclosed later.":
    "Die NFTS RANDOM EFFECT ändern ihre Fähigkeiten alle 4 Monate. Der Nutzen ist größer, je nach Seltenheit des NFT. Es gibt auch Zugang zu anderen Vorteilen, einschließlich der VIP-Club (Call nft & Token), Whitelist, Rabatte und andere Vorteile, die später offenbart werden.",
  "Flash Technologies Roadmap": "Flash Technologies Roadmap",
  "August 2021": "August 2021",
  "Market study and meeting with professionals for the feasibility of the project.":
    "Marktstudie und Treffen mit Fachleuten, um die Durchführbarkeit des Projekts zu prüfen.",
  "September 2021": "September 2021",
  "Definition of the project and creation of the whitepaper.":
    "Definition des Projekts und Erstellung des Whitepapers.",
  "October 2021": "Oktober 2021",
  "Creation of the team of developers. Creation of the Flash Token Website.":
    "Zusammenstellung des Entwicklerteams. Erstellung der Flash Token Website.",
  "November 2021": "November 2021",
  "Implementation of the Marketing strategy. Creation of the money transfer platform website. Meeting with influencers for the promotion of Flash Token. Launch of the Flash Token on the Bsc.":
    "Umsetzung der Marketingstrategie. Erstellung der Website der Geldtransferplattform. Treffen mit Influencern für die Promotion des Flash Token. Einführung des Flash Token auf der Bsc.",
  "December 2021": "Dezember 2021",
  "Promotion of the Flash Token by influencers.":
    "Werbung für den Flash Token durch Influencer.",
  "January 2022": "Januar 2022",
  "Launch of the 1st NFT collection. Launch of the Flash Token on the Bsc.":
    "Einführung der 1. NFT-Kollektion. Einführung des Flash Token auf der Bsc.",
  "February 2022": "Februar 2022",
  "Release of the beta version of the money transfer. Coming out of the Nft mint platform Deployment.":
    "Veröffentlichung der Beta-Version des Geldtransfers. Herauskommen aus der Nft mint Plattform Bereitstellung",
  2022: "2022",
  "Launch of Flash Technologies website":
    "Start der Website von Flash Technologies",
  "Unveiling of the first Flash Transfer partners":
    "Enthüllung der ersten Flash-Transfer-Partner",
  "Launch of Flash Audit": "Einführung von Flash Audit",
  "Vip Club Launch (only for the 200 Nft)":
    "Vip Club Launch (nur für die 200 Nft)",
  "Launch of the advertising campaign with influencers + new ambassadors":
    "Start der Werbekampagne mit Influencern + neuen Botschaftern",
  "Development of the Audit platform": "Entwicklung der Audit-Plattform",
  "Development of the Staking platform": "Entwicklung der Staking-Plattform",
  "Beta Launch Flash Transfer": "Beta-Start Flash-Transfer",
  "Flash x Binance": "Blitzlicht x Binance",
  "Launch Flash Wallet extension & application Android + IOS":
    "Flash Wallet Erweiterung & Anwendung starten Android + IOS",
  "AML compliance": "AML-Einhaltung",
  "Flash x Synaps": "Blitzlicht x Synapsen",
  "Flash x Certik": "Blitzlicht x Certik",
  "Launch Flash Transfer extension & application Android + IOS":
    "Starten Sie die Flash Transfer Erweiterung & Anwendung Android + IOS",
  2023: "2023",
  2024: "2024/2025",
  2026: "2026",

  "Launch of Flash Transfer in the world":
    "Start von Flash Transfer in der Welt",
  "Flash Transfer integration into WhatsApp and Telegram":
    "Flash Transfer in WhatsApp & Telegram integrieren",
  "Stellar blockchain integration": "Integration der Stellar-Blockchain",
  "Launch of $Flash on Ethereum": "Launch von $Flash auf Ethereum",
  "Launch of $FLASH IDO": "Start des $FLASH-IDO",

  "$Flash": "$Flash",
  Buyback: "Buyback",
  Utility: "Nutzen",
  Ethereum: "Ethereum",
  "Coming Soon": "Demnächst",

  "Flash 3.0": "FLASH",
  "Flash Token": "FTT Token",
  "Flash token is a governance token tied to the entire Flash Technologies ecosystem. 2% of all revenues (transaction fees) will be reinvested in the token in the form of a monthly Buyback. Flash token is also linked to NFT Airdrops, where holders will receive 1% of the monthly token volume directly. The token is cross-chain, meaning it can be purchased on multiple networks with the same address. It can also be transferred to other wallets without paying transfer fees.":
    "Der FTT Token ist ein Governance-Token, der an das gesamte Ökosystem von Flash Technologies gebunden ist. 2 % aller Einnahmen (Transaktionsgebühren) werden in Form eines monatlichen Rückkaufs in den Token reinvestiert. Der FTT Token ist auch mit den NFT 'Airdrops' verbunden, bei denen die Inhaber 1 % des monatlichen Token-Volumens direkt erhalten. Der Token ist kettenübergreifend, d.h. er kann in mehreren Netzwerken mit der gleichen Adresse erworben werden. Er kann auch auf andere Wallets übertragen werden, ohne dass Übertragungsgebühren anfallen.",
  "Flash is a token on Ethereum that aims to become a means of exchange within the Flash Technologies ecosystem, which includes services such as Flash-transfer.com, Flash Wallet, Dead Wallet, and other services. It will offer various benefits based on the number of tokens held by the user.":
    "Flash ist ein Token auf Ethereum, der ein Tauschmittel innerhalb des Ökosystems von Flash Technologies werden soll, zu dem Dienste wie Flash-transfer.com, Flash Wallet, Dead Wallet und weitere Services gehören. Er bietet verschiedene Vorteile je nach Anzahl der vom Nutzer gehaltenen Token.",
  "Contract address": "Vertragsadresse",
  "Token name": "Token-Name",
  "Total Supply": "Gesamtangebot",
  Symbol: "Symbol",
  "Available on": "Verfügbar am",
  "Available Soon on": "Demnächst verfügbar auf",
  "Audit Flash": "Audit-Blitz",
  "Backers": "Backers",
  "Limited edition: only 200 NFTs on Ethereum.": "Limitierte Auflage: nur 200 NFTs auf Ethereum.",
  "LIVE": "LIVE",
  "$FLASH presale on PinkSale": "$FLASH-Presale auf PinkSale",
  "Take part": "Teilnehmen",
  "Legacy airdrop V1": "Legacy airdrop V1",
  "Private sale": "Private sale",
  "Liquidity Pool": "Liquidity Pool",
  "Presale Pinksale": "Presale Pinksale",
  "Team / Marketing": "Team / Marketing",
  Rewards: "Belohnungen",
  DAYS: "DAYS",
  HOURS: "HOURS",
  MINUTES: "MINUTES",
  SECONDS: "SECONDS",
  "Integration of dead wallet feature in Flash Wallet": "Integration of dead wallet feature in Flash Wallet",
  "Flash Wallet x Wallet Connect partnership":
    "Partnerschaft Flash Wallet x Wallet Connect",
  "Opening of our branch in France": "Opening of our branch in France",
  "New partner in money transfer": "New partner in money transfer",
  "Finalization of the Flash Transfer website": "Finalization of the Flash Transfer website",
  "Flash Wallet UI/UX update": "UI/UX-Update von Flash Wallet",
  "Exchange listing (Lbank & Biconomy)": "Exchange listing (Lbank & Biconomy)",
  "Exchange listing": "Exchange listing (Lbank & Biconomy)",

  "Auditing Flash Transfer & Flash Wallet apps":
    "Prüfung von Flash Transfer- und Flash Wallet-Apps",
  "Flash x Orange Money": "Blitz x Orange Geld",
  "Flash x MTN": "Flash x MTN",
  "Launch of Flash Payment": "Einführung von Flash Payment",
  "Launch of Dead Wallet": "Einführung von Dead Wallet",
  "Waiting for PSAN registration in France":
    "Warten auf die PSAN-Registrierung in Frankreich",
  "Waiting for VASP registration in UAE":
    "Warten auf die VASP-Registrierung in den VAE",

  Press: "Presse",
  "Press & Brand Kit": "Presse- & Brand-Kit",
  "Press kit intro":
    "Offizielle Logos, Farben und Texte für Journalisten, Partner und Creator. Dateien unverändert verwenden — die Flash-Münze nicht neu zeichnen.",
  "Download brand kit": "Brand-Kit herunterladen",
  Logos: "Logos",
  "Logos intro":
    "SVG bevorzugen. Goldmünze auf dunklem Hintergrund. Mono-Versionen für einfarbigen Druck.",
  "Official coin": "Offizielle Münze",
  Icon: "Icon",
  "Icon black": "Icon schwarz",
  "Icon white": "Icon weiß",
  Lockup: "Lockup",
  Wordmark: "Wortmarke",
  Colors: "Farben",
  "Colors intro": "Klicken Sie auf eine Farbe, um den Hex-Wert zu kopieren.",
  Gold: "Gold",
  "Gold highlight": "Gold hell",
  "Gold deep": "Gold tief",
  Black: "Schwarz",
  Surface: "Fläche",
  Muted: "Grau",
  White: "Weiß",
  Copied: "Kopiert",
  Copy: "Kopieren",
  Typography: "Typografie",
  "Typography intro":
    "Manrope ist die Flash-Schrift — ExtraBold für Titel, Regular für Fließtext.",
  "Typography sample": "Finanzielle Freiheit ist unterwegs.",
  Usage: "Nutzung",
  Do: "Do",
  "Don't": "Don't",
  "Usage do 1": "Nur offizielle Dateien aus diesem Kit verwenden",
  "Usage do 2": "Den Blitz auf der Goldmünze schwarz lassen",
  "Usage do 3": "Freiraum um das Logo lassen",
  "Usage do 4": "#FBBF04 als einziges Markengelb verwenden",
  "Usage dont 1": "Nicht umfärben, umranden oder Schatten hinzufügen",
  "Usage dont 2": "Münze nicht drehen, strecken oder beschneiden",
  "Usage dont 3": "Goldmünze nicht auf Gelb platzieren",
  "Usage dont 4": "Blitz nicht durch ein anderes Symbol ersetzen",
  "Press boilerplate": "Pressetext",
  "Press boilerplate text":
    "Flash Technologies baut ein Geldtransfer-Ökosystem: Flash Transfer ermöglicht Kauf, Versand oder Auszahlung von Krypto über ein Händlernetz; Flash Wallet ist eine Non-Custodial-Wallet mit Dead-Wallet-Smart-Contract; Flash Dex bündelt Swap- und Bridge-Routen. Büros in Dubai, Paris und Abidjan.",
  "Press contact": "Pressekontakt",
  "Press contact intro": "Für Interviews, Assets oder Partnererwähnungen:",
};
